import { eqCssMobile } from './utils';
export var browserUtils;
(function (browserUtils) {
    var _isFirefox = null;
    var _isIE = null;
    function isIE() {
        return eval('/*@cc_on!@*/false || !!document.documentMode');
    }
    browserUtils.isIE = isIE;
    function isFirefox() {
        if (_isFirefox === null) {
            var ua = navigator.userAgent;
            _isFirefox = ua.toLowerCase().indexOf('firefox') > -1;
        }
        return _isFirefox;
    }
    browserUtils.isFirefox = isFirefox;
    var _detectedIsMobileMode = false;
    var _isMobileMode = undefined;
    var detectIsMobileMode = function () {
        var oldValue = isMobileMode();
        _detectedIsMobileMode = window.matchMedia('only screen and (max-width: 840px)').matches
            || window.matchMedia('only screen and (max-height: 420px)').matches;
        var newValue = isMobileMode();
        if (newValue !== oldValue && mobileModeChangeHandler) {
            mobileModeChangeHandler(newValue);
        }
    };
    detectIsMobileMode();
    window.addEventListener('resize', function () { return detectIsMobileMode(); });
    function isMobileMode() {
        if (_isMobileMode !== undefined) {
            return _isMobileMode;
        }
        else {
            return _detectedIsMobileMode;
        }
    }
    browserUtils.isMobileMode = isMobileMode;
    function setIsMobileMode(value) {
        var oldValue = isMobileMode();
        _isMobileMode = value;
        var newValue = isMobileMode();
        if (newValue !== oldValue && mobileModeChangeHandler) {
            mobileModeChangeHandler(newValue);
        }
    }
    browserUtils.setIsMobileMode = setIsMobileMode;
    var mobileModeChangeHandler;
    function onMobileModeChanged(callback) {
        mobileModeChangeHandler = callback;
    }
    browserUtils.onMobileModeChanged = onMobileModeChanged;
    function getMobileCssClass() {
        return isMobileMode() ? eqCssMobile : null;
    }
    browserUtils.getMobileCssClass = getMobileCssClass;
})(browserUtils || (browserUtils = {}));
//# sourceMappingURL=browser_utils.js.map